// selectors/index.js

// Existing selectors
import userManagement from '../../POS/services/userManagement';

// Add the tax selector
export const getTaxExplicit = (state) => state.tax.taxExplicit;
export const getTaxImplicit = (state) => state.tax.taxImplicit;
export const getRole = (state) => {
  // First check if role is stored in Redux
  if (state?.userAuth?.role) {
    return state.userAuth.role;
  }

  // If not, try to get from token
  const token = getToken(state);
  if (token) {
    return userManagement.getUserRole(token);
  }

  return null;
};

export const getToken = (state) => {
  // Check multiple possible locations
  debugger;
  return state?.userAuth?.user?.data?.accessToken || state?.userAuth?.user?.accessToken || localStorage.getItem('Token');
};

export const getUserId = (state) => state.userAuth.userNo;

export const getUserName = (state) => {
  return state?.userAuth?.user?.data?.fullName || state?.userAuth?.user?.fullName;
};
// Other selectors (if you need them for other features)
export const getProfile = (state) => state?.userAuth?.user?.profileImage;
export const getName = (state) => state?.userAuth?.user?.fullName;

// export const getRole = (state) => userManagement.getUserRole(getToken(state));
// export const getRole = (state) => {
//   debugger;
//   return state?.userAuth?.user?.data?.role;
// };

// export const getUserId = (state) => userManagement.getUserId(getToken(state));
// export const getUserId = (state) => state?.userAuth?.user?.userNo;
// export const getUserName = (state) => userManagement.getUserName(getToken(state));
// export const getUserName = (state) => state?.userAuth?.user?.fullName;
export const getCartData = (state) => state?.cart?.items;
export const getComboData = (state) => state?.comboCart?.items;
export const getTableData = (state) => state?.table?.items;
export const getOrderEditData = (state) => state?.orderEdit?.items;
export const getEmployeData = (state) => state?.employeData;
export const getUserRights = (state) => state?.userDetails;

// Add on selectors
export const getAddons = (state) => state.addons.addons;
export const getAddonById = (state, id) => state.addons.addons.find((addon) => addon.id === id);

export const CURRENCY = 'CURRENCY';
